<template>
  <div class="process-tips">
    <div v-for="(item, idx) in list" :key="idx" class="tip-cell">
      <RegistrationIcon :value="item.value" />
      <div>
        <div class="title">
          {{ item.title }}
        </div>
        <div class="tip-detail">
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RegistrationIcon from '../RegistrationIcon'
export default {
  name: 'ProcessTips',
  components: {
    RegistrationIcon
  },
  computed: {
    list() {
      return [
        {
          value: 0,
          title: this.$t('trade.acct-status.no-commission.title'),
          content: this.$t('trade.acct-status.no-commission.content')
        },
        {
          value: 1,
          title: this.$t('trade.acct-status.no-account-fee.title'),
          content: this.$t('trade.acct-status.no-account-fee.content')
        },
        {
          value: 2,
          title: this.$t('trade.acct-status.no-data-fee.title'),
          content: this.$t('trade.acct-status.no-data-fee.content')
        },
        {
          value: 3,
          title: this.$t('trade.acct-status.no-maintenance-fee.title'),
          content: this.$t('trade.acct-status.no-maintenance-fee.content')
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.process-tips {
  flex: 1;
  width: 100%;
  min-height: 0;
  padding: 40px 30px 40px 40px;
  overflow-y: auto;

  .tip-cell {
    display: flex;
    margin-bottom: 22px;
    .reg-icon {
      margin-right: 15px;
    }
    .tip-detail {
      font-size: 12px;
      font-weight: 500;
      color: @grey;
    }
    .title {
      font-size: 14px;
      font-weight: bold;
      color: var(--default-font-color);
      margin-bottom: 7px;
      white-space: nowrap;
    }
  }
}
</style>
